export default __webpack_public_path__ + "static/media/AcIconAlert.1478fffd.svg";